import { request } from './apiClient'

export type FleetPositionStatus = 'recent' | 'stale' | 'never_seen'
export type FleetLifecycleStatus = 'active' | 'delivered' | 'trials'

export interface DeliveredFleetVessel {
  fleet_vessel_id: string
  project_id: string | null
  project_name: string | null
  hull_number: string | null
  imo_number: string | null
  mmsi: string
  vessel_name: string | null
  vessel_type: string | null
  ship_owner: string | null
  delivered_at: string | null
  shipyard_name: string | null
  lifecycle_status: FleetLifecycleStatus
  source_status: string | null
  flag: string | null
  call_sign: string | null
  planned_year: number | null
  latitude: number | null
  longitude: number | null
  speed_over_ground: number | null
  course_over_ground: number | null
  true_heading: number | null
  navigational_status: number | null
  source_message_type: string | null
  last_seen_at: string | null
  position_status: FleetPositionStatus
}

export interface DeliveredFleetResponse {
  generated_at: string
  stale_after_minutes: number
  vessels: DeliveredFleetVessel[]
}

export async function fetchDeliveredFleet(): Promise<DeliveredFleetResponse> {
  const { data, error } = await request<DeliveredFleetResponse>('GET', '/api/delivered-fleet')
  if (error || !data) throw new Error(error?.message ?? 'Failed to load delivered fleet')
  return data
}
